import { render, staticRenderFns } from "./ProfileSummary.vue?vue&type=template&id=d13e979a&scoped=true&"
import script from "./ProfileSummary.vue?vue&type=script&lang=js&"
export * from "./ProfileSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSummary.vue?vue&type=style&index=0&id=d13e979a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e979a",
  null
  
)

export default component.exports